const REWARD_TYPE_BY_MEMBERSHIP = [
  { id: 'O', description: 'Beneficio' },
  { id: 'A', description: 'Reward de uso único' },
  { id: 'S', description: 'Beneficio especial' },
]

export { REWARD_TYPE_BY_MEMBERSHIP }
